__turbopack_context__.v({
  "card": "SquareCard-module__MD2e6G__card",
  "link": "SquareCard-module__MD2e6G__link",
  "small": "SquareCard-module__MD2e6G__small",
  "title": "SquareCard-module__MD2e6G__title",
});
